var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheBas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_47",
    "data-name": "Groupe 47",
    transform: "translate(-191 -572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 80,
    height: 80,
    transform: "translate(191 572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_44",
    "data-name": "Groupe 44",
    transform: "translate(-729.106 -1455.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2093.228)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2093.228)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2087.449)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2087.449)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2087.449)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2087.449)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 5.779,
    height: 5.779,
    transform: "translate(942.664 2081.671)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2081.671)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2081.671)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2081.671)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2081.671)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 5.779,
    height: 5.779,
    transform: "translate(971.557 2081.671)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 5.779,
    height: 5.779,
    transform: "translate(936.885 2075.892)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_625",
    "data-name": "Rectangle 625",
    width: 5.779,
    height: 5.779,
    transform: "translate(942.664 2075.892)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_626",
    "data-name": "Rectangle 626",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2075.892)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2075.892)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2075.892)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2075.892)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 5.779,
    height: 5.779,
    transform: "translate(971.557 2075.892)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 5.779,
    height: 5.779,
    transform: "translate(977.336 2075.892)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 5.779,
    height: 5.779,
    transform: "translate(931.106 2070.113)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_633",
    "data-name": "Rectangle 633",
    width: 5.779,
    height: 5.779,
    transform: "translate(936.885 2070.113)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    width: 5.779,
    height: 5.779,
    transform: "translate(942.664 2070.113)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2070.113)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2070.113)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2070.113)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2070.113)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    "data-name": "Rectangle 639",
    width: 5.779,
    height: 5.779,
    transform: "translate(971.557 2070.113)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_640",
    "data-name": "Rectangle 640",
    width: 5.779,
    height: 5.779,
    transform: "translate(977.336 2070.113)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_641",
    "data-name": "Rectangle 641",
    width: 5.779,
    height: 5.779,
    transform: "translate(983.115 2070.113)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    width: 5.779,
    height: 5.779,
    transform: "translate(931.106 2064.334)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_643",
    "data-name": "Rectangle 643",
    width: 5.779,
    height: 5.779,
    transform: "translate(936.885 2064.334)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 5.779,
    height: 5.779,
    transform: "translate(942.664 2064.334)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_645",
    "data-name": "Rectangle 645",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2064.334)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_646",
    "data-name": "Rectangle 646",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2064.334)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_647",
    "data-name": "Rectangle 647",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2064.334)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2064.334)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 5.779,
    height: 5.779,
    transform: "translate(971.557 2064.334)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_650",
    "data-name": "Rectangle 650",
    width: 5.779,
    height: 5.779,
    transform: "translate(977.336 2064.334)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 5.779,
    height: 5.779,
    transform: "translate(983.115 2064.334)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 5.779,
    height: 5.779,
    transform: "translate(936.885 2058.555)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    width: 5.779,
    height: 5.779,
    transform: "translate(942.664 2058.555)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2058.555)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2058.555)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2058.555)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2058.555)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    width: 5.779,
    height: 5.779,
    transform: "translate(971.557 2058.555)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_659",
    "data-name": "Rectangle 659",
    width: 5.779,
    height: 5.779,
    transform: "translate(977.336 2058.555)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2052.777)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_661",
    "data-name": "Rectangle 661",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2052.777)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_662",
    "data-name": "Rectangle 662",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2052.777)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2052.777)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2046.998)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_665",
    "data-name": "Rectangle 665",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2046.998)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_666",
    "data-name": "Rectangle 666",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2046.998)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2046.998)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_668",
    "data-name": "Rectangle 668",
    width: 5.779,
    height: 5.779,
    transform: "translate(948.443 2041.219)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_669",
    "data-name": "Rectangle 669",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2041.219)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_670",
    "data-name": "Rectangle 670",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2041.219)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 5.779,
    height: 5.779,
    transform: "translate(954.221 2035.44)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_672",
    "data-name": "Rectangle 672",
    width: 5.779,
    height: 5.779,
    transform: "translate(960 2035.44)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_673",
    "data-name": "Rectangle 673",
    width: 5.779,
    height: 5.779,
    transform: "translate(965.779 2041.219)",
    fill: "#3d3d3d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheBas);
export default __webpack_public_path__ + "static/media/fleche_bas.82548fdc65a8942678c23ce777e18d73.svg";
export { ForwardRef as ReactComponent };